"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
const CommonDto_1 = require("../dto/CommonDto");
class Link {
    constructor() {
        this.type = CommonDto_1.LinkTypeDto.WEB;
        this.url = "";
        this.text = "";
    }
    static fromDto(linkDto) {
        const link = new Link();
        link.type = linkDto.type;
        link.url = linkDto.url;
        link.text = linkDto.text ? linkDto.text : "";
        return link;
    }
    toDto() {
        const resultDto = {
            type: this.type,
            url: this.url,
        };
        if (this.text) {
            resultDto.text = this.text;
        }
        return resultDto;
    }
    get textOrUrl() {
        return this.text ? this.text : this.url;
    }
    get isFaIcon() {
        switch (this.type) {
            case CommonDto_1.LinkTypeDto.FB:
            case CommonDto_1.LinkTypeDto.INSTAGRAM:
            case CommonDto_1.LinkTypeDto.LINKED_IN:
            case CommonDto_1.LinkTypeDto.TWITTER:
            case CommonDto_1.LinkTypeDto.YOUTUBE:
            case CommonDto_1.LinkTypeDto.VK:
            case CommonDto_1.LinkTypeDto.TELEGRAM:
            case CommonDto_1.LinkTypeDto.PHONE:
            case CommonDto_1.LinkTypeDto.WHATSAPP:
                return true;
            default:
                return false;
        }
    }
    get faIcon() {
        switch (this.type) {
            case CommonDto_1.LinkTypeDto.FB:
                return ['fab', 'facebook'];
            case CommonDto_1.LinkTypeDto.INSTAGRAM:
                return ['fab', 'instagram'];
            case CommonDto_1.LinkTypeDto.LINKED_IN:
                return ['fab', 'linkedin'];
            case CommonDto_1.LinkTypeDto.TWITTER:
                return ['fab', 'twitter'];
            case CommonDto_1.LinkTypeDto.YOUTUBE:
                return ['fab', 'youtube'];
            case CommonDto_1.LinkTypeDto.VK:
                return ['fab', 'vk'];
            case CommonDto_1.LinkTypeDto.TELEGRAM:
                return ['fab', 'telegram'];
            case CommonDto_1.LinkTypeDto.PHONE:
                return ['fas', 'phone-square'];
            case CommonDto_1.LinkTypeDto.WHATSAPP:
                return ['fab', 'whatsapp'];
        }
        return [];
    }
    get bvIcon() {
        switch (this.type) {
            case CommonDto_1.LinkTypeDto.EMAIL:
                return "at";
            default:
                return "link45deg";
        }
    }
    get href() {
        switch (this.type) {
            case CommonDto_1.LinkTypeDto.EMAIL:
                return "mailto:" + this.url;
            case CommonDto_1.LinkTypeDto.PHONE:
                return "tel:" + this.url;
            default:
                return this.url;
        }
    }
    get inputType() {
        switch (this.type) {
            case CommonDto_1.LinkTypeDto.PHONE:
                return "tel";
            case CommonDto_1.LinkTypeDto.EMAIL:
                return "email";
            default:
                return "url";
        }
    }
    get isSocialNetwork() {
        switch (this.type) {
            case CommonDto_1.LinkTypeDto.FB:
            case CommonDto_1.LinkTypeDto.INSTAGRAM:
            case CommonDto_1.LinkTypeDto.LINKED_IN:
            case CommonDto_1.LinkTypeDto.TWITTER:
            case CommonDto_1.LinkTypeDto.YOUTUBE:
            case CommonDto_1.LinkTypeDto.VK:
            case CommonDto_1.LinkTypeDto.TELEGRAM:
            case CommonDto_1.LinkTypeDto.WHATSAPP:
                return true;
            default:
                return false;
        }
    }
    get isPhone() {
        return this.type === CommonDto_1.LinkTypeDto.PHONE;
    }
    get isEmail() {
        return this.type === CommonDto_1.LinkTypeDto.EMAIL;
    }
    get isWeb() {
        return this.type === CommonDto_1.LinkTypeDto.WEB;
    }
}
exports.Link = Link;
